import React, { useState } from "react";
import { PhoneOutlined, MessageOutlined, CloseOutlined } from "@ant-design/icons";
import LineImg from "../../assets/images/png/line.png";

export default function FloatingButton() {
    const [isOpen, setIsOpen] = useState(false);

    const buttonStyle = {
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        cursor: "pointer",
        border: "none",
        position: "fixed",
        right: "20px",
        bottom: "20px",
        color: "#fff",
        transition: "background-color 0.3s ease, transform 0.3s ease",
    };

    const mainButtonStyle = {
        ...buttonStyle,
        backgroundColor: isOpen ? "#FF4C4C" : "#FD0097",
    };

    const optionButtonStyle = (bottomOffset, bgColor) => ({
        ...buttonStyle,
        backgroundColor: bgColor,
        bottom: bottomOffset,
        opacity: isOpen ? 1 : 0,
        transform: isOpen ? "translateY(0)" : "translateY(20px)",
        visibility: isOpen ? "visible" : "hidden",
        transition: "opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease",
    });

    return (
        <div style={{ position: "fixed", bottom: "20px", right: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            {isOpen && (
                <>
                  
                    <button
                        style={optionButtonStyle("90px", "#28C76F")}
                        onClick={() => window.location.href = "tel:+66818452288"}
                        aria-label="Call us"
                    >
                        <PhoneOutlined style={{ fontSize: "24px" }} />
                    </button>

                  
                    <button
                        style={optionButtonStyle("150px", "#2CB742")}
                        onClick={() => window.open("https://page.line.me/justbuyme", "_blank")}
                        aria-label="Chat on LINE"
                    >
                        <img src={LineImg} alt="LINE" style={{ width: "28px", height: "28px" }} />
                    </button>
                </>
            )}

   
            <button
                style={mainButtonStyle}
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Toggle Floating Button"
            >
                {isOpen ? <CloseOutlined style={{ fontSize: "24px" }} /> : <MessageOutlined style={{ fontSize: "24px" }} />}
            </button>
        </div>
    );
}